import React from 'react';
import {FeaturesEnum, HelpCenterEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {ServicePointsDeprecated} from './components/ServicePointsDeprecated';
import {ServicePoints} from './components/ServicePoints';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {MainHeader} from 'presentation/components/MainHeader';

const {title} = translations['pt-br'].privateFlow.help.ourAddresses;

export function ServicePointsAddresses() {
	const navigate = useNavigate();
	const {isEnabled: showNewLayout} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_OUR_ADDRESSES_NEW_LAYOUT,
	);

	const handleBack = () => {
		navigate(HelpCenterEnum.HELP);
	};

	return (
		<PageWrapperLayout title={title}>
			<MainHeader title={title} handleBack={handleBack} hideProfileMenu />

			{showNewLayout ? <ServicePoints /> : <ServicePointsDeprecated />}
		</PageWrapperLayout>
	);
}
